<template>
  <div class="app-container">
    <el-card>
      <span class="mr-10">
        <media-select
          v-model="jrtt_tracking.params.advertiser_id"
          type="jrtt"
          @change="changeAdvertiser"
        />
      </span>
      <el-button
        icon="el-icon-refresh"
        size="mini"
        :disabled="!jrtt_tracking.params.advertiser_id"
        type="primary"
        @click="updateTable"
      >刷新表格</el-button>
    </el-card>
    <el-card class="mt-20">
      <div class="table-toolbar-wrapper">
        <el-button icon="el-icon-plus" type="primary" size="mini" @click="addNewTrack">新建应用转化</el-button>
      </div>
      <app-table
        v-if="jrtt_tracking.params.advertiser_id"
        ref="my-table"
        :table-props="{ maxHeight: 550 }"
        :table-key="table_key"
        :tablep="jrtt_tracking.params"
        :page-size="15"
        :get-data="getConversionList"
      />
      <el-empty v-else description="请先选择广告主" />
    </el-card>
    <!-- 批量新增转化抽屉 -->
    <el-drawer
      title="批量新增转化"
      :visible.sync="add_track_show"
      direction="rtl"
      size="1200px"
      :before-close="closeAddDialog"
    >
      <h2 slot="title">批量新增转化</h2>
      <div v-if="add_track_show" class="create-track-box">
        <create-track
          @config="configAddDialog"
          @cancel="closeAddDialog"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
const enum_json = require('@/assets/json/enum.json');
// 转化接口
import ConvertResource from '@/api/tool/convert/jrtt';
const convertResource = new ConvertResource();
import { isEmpty } from '@/utils/is';

export default {
  name: 'JrttTracking',
  components: {
    'app-table': () => import('@/components/app-table'),
    'create-track': () => import('./components/create-track'),
    'media-select': () => import('@/views/system/media-user-manage/function/media-select'),
  },
  data() {
    return {
      enum_list: enum_json,
      // 表格头部
      table_key: require('./module/table-key.js')(this),
      seach_input: '',
      add_track_show: false,
      // 获取转化
      jrtt_tracking: {
        loading: false,
        params: {
          advertiser_id: '',
          filtering: [],
          page: 1,
          limit: 15,
        },
        response: {},
      },
      // 获取应用
      get_promoted: {
        params: {
          advertiser_id: '',
        },
        response: {},
      },
    };
  },
  methods: {
    // 获取转化列表
    getConversionList(){
      return new Promise((resolve, reject) => {
        convertResource
          .getApi(this.jrtt_tracking.params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 改变广告主
    changeAdvertiser(val){
      if (isEmpty(val)) {
        return;
      }
      this.updateTable();
    },

    // 新建应用转化
    addNewTrack(){
      this.add_track_show = true;
    },

    // 更新表格
    updateTable(){
      if (this.$refs['my-table']){
        this.$refs['my-table'].seekTable();
      }
    },

    // 确定
    configAddDialog(){
      this.updateTable();
      this.add_track_show = false;
    },

    // 取消
    closeAddDialog(){
      this.$confirm('存在未提交的配置信息，确定关闭当前窗口吗', '提示').then(() => {
        this.add_track_show = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  background: #f5f6f7;
  min-height: calc(100vh - 84px);
  .create-track-box {
    padding: 0px 20px 100px;
  }
}
</style>
